module.exports = __webpack_public_path__ + "7ef688cd65db3e20439ee8bffdb1bed8.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/eviction.png
// module id = 605
// module chunks = 0